const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozODUsImNvbmdyZXNzSWQiOjExOTAsImRhdGUiOiIyMDIwLTA2LTA4VDEwOjM5OjIyLjc0M1oiLCJpYXQiOjE1OTE2MTI3NjJ9.MCvypsRm0TufBNFqiXIbx6HWQnmvvjL475Ea0ehds5Q';
const API_URL = 'https://wclh2020.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozODYsImNvbmdyZXNzSWQiOjExOTAsImRhdGUiOiIyMDIwLTA2LTA4VDEwOjQxOjAwLjE2NloiLCJpYXQiOjE1OTE2MTI4NjB9.iIIRYjN-UwYxbtFrJbpMgTbGPyUTa9AgB7DUNhbtAgE';
// const API_URL = 'http://localhost:8000/api';

const CONGRESS_ID = 1190;
const SUBMISSION_SYSTEM_URL = 'https://wclh2020.abstract.documedias.systems/api/v1/export/transformed/filtered/single/abstract/{{id}}/planner/export';

const FILE_SERVER_URL = 'https://fileserver.documedias.com/';
const FILE_SERVER_FOLDER = '2c332516-a4d4-11ea-bb37-0242ac130002';

const MAILING_IMAGE_MAX_SIZE = 524288;
const MAILING_IMAGE_ALLOWED_TYPES = ['image/png', 'image/jpeg'];

export {
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  API_URL,
  CONGRESS_ID,
  SUBMISSION_SYSTEM_URL,
  FILE_SERVER_URL,
  FILE_SERVER_FOLDER,
  MAILING_IMAGE_MAX_SIZE,
  MAILING_IMAGE_ALLOWED_TYPES,
}
